import { useFormMutation } from "@coideo/barrani";
import { useAuth } from "context/auth-context";
import { type LoginData } from "utils/auth-client";
import { type CustomError } from "utils/parse-error";

function useLogin() {
  const { login } = useAuth();

  return useFormMutation<void, CustomError, LoginData>(login);
}

export { useLogin };
